import { InfiniteData, infiniteQueryOptions } from '@tanstack/react-query'
import {
  TransactionActivitiesParams,
  TransactionActivitiesResponse,
  TransactionActivity,
} from 'src/queries/transactionActivities/transactionActivities.models'
import { getTransactionActivities } from 'src/queries/transactionActivities/transactionActivities.network'

const DEFAULT_LIMIT = 50

const normalizeParams = (
  params?: TransactionActivitiesParams,
): TransactionActivitiesParams => ({
  limit: params?.limit ?? DEFAULT_LIMIT,
})

export const transactionActivitiesQueryKeys = {
  all: () => ['transactionActivities'] as const,
  list: (
    transactionId: string | undefined,
    params: TransactionActivitiesParams,
  ) =>
    [...transactionActivitiesQueryKeys.all(), transactionId, params] as const,
}

export const selectTransactionActivities = (
  data: InfiniteData<TransactionActivitiesResponse, string | undefined>,
): TransactionActivity[] => data.pages.flatMap((page) => page.items)

export const transactionActivitiesQueries = {
  list: (
    transactionId: string | undefined,
    params?: TransactionActivitiesParams,
  ) => {
    const normalizedParams = normalizeParams(params)

    return infiniteQueryOptions({
      queryKey: transactionActivitiesQueryKeys.list(
        transactionId,
        normalizedParams,
      ),
      queryFn: ({ pageParam }) =>
        getTransactionActivities(transactionId, {
          ...normalizedParams,
          ...(pageParam !== undefined ? { before: pageParam } : {}),
        }),
      enabled: Boolean(transactionId),
      initialPageParam: undefined as string | undefined,
      getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
      retry: (failureCount, error) => {
        const status =
          error && typeof error === 'object' && 'status' in error
            ? error.status
            : undefined
        return status !== 400 && status !== 404 && failureCount < 2
      },
    })
  },
}
